// Load css file
const loadCss = (fileName) => {    
  const fileId = `${fileName.toUpperCase()?.replace('-', '')}CSS`  
  if (!document.getElementById(fileId)){    
      const head  = document.getElementsByTagName('head')[0];
      const link  = document.createElement('link');
      link.id   = fileId;
      link.rel  = 'stylesheet';
      link.type = 'text/css';
      link.href = document.getElementById('MainCssPath').href.replace('/assets/main.css', `/assets/${fileName}.css`);
      link.media = 'all';
      head.appendChild(link);
  }
}

// Load js file
const loadScript = (fileName) => {    
  const fileId = `${fileName.toUpperCase()?.replace('-', '')}JS`  
  if (!document.getElementById(fileId)){    
      const head  = document.getElementsByTagName('head')[0];
      const script  = document.createElement('script');
      script.id   = fileId;      
      script.type = 'text/javascript';
      script.src = document.getElementById('MainJsPath').src.replace('/assets/main.js', `/assets/${fileName}.js`);      
      head.appendChild(script);
  }
}

// Scroll animation observer
const scrollAnimationObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {      
      if(entry.isIntersecting){
        entry.target.classList.add('scroll-animation--active');          
        scrollAnimationObserver.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.25
  }
);

document.querySelectorAll('.scroll-animation').forEach((el, i) => {
  scrollAnimationObserver.observe(el);
});

// Add helper class when announcement bar is enabled
window.addEventListener('DOMContentLoaded', () => {
  if(document.querySelector('.announcement-bar') != null) {        
    document.body.classList.add('is-announcement-bar');
  }
});

// Helper functions
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.keydown = function (event) {    
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.    
    if (event.target === last && !event.shiftKey) {      
      console.log('return focus to 1', elements[elements.length - 2])
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      console.log('return focus to last')
      event.preventDefault();
      last.focus();
    }
  };

  trapFocusHandlers.focusin = (event) => {
    //if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };  

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('.details--active');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('.summary');
  openDetailsElement.classList.remove('details--active');
  summaryElement.setAttribute('aria-expanded', false);
  if(document.body.classList.contains('mmenu--open')){
    document.body.classList.remove('mmenu--open')
  }  
  summaryElement.focus();    
}

// Details animation
document.querySelectorAll('.details .summary').forEach((summary) => {      
  const details = summary.closest('.details');
  const detailsContent = details.querySelector('.details__content');

  summary.addEventListener('click', (event) => {        
    if(event.currentTarget.classList.contains('menu-item')) {      
      if (details.classList.contains('details--active')) {        
        detailsContent.style.maxHeight = '0';
      } else {        
        detailsContent.style.maxHeight = detailsContent.scrollHeight + details.querySelector('.details--active .details__content').scrollHeight + 'px';
        detailsContent.closest('.menu-level-1').style.maxHeight = detailsContent.closest('.menu-level-1').scrollHeight + details.querySelector('.details--active .details__content').scrollHeight + 'px';
      }     

      event.currentTarget.closest('ul').querySelectorAll('li > .details').forEach((otherDetails) => {
        if (otherDetails !== details) {          
          otherDetails.classList.remove('details--active');                              
          otherDetails.querySelector('.details__content').style.maxHeight = '0';
        } 
      });      
    }
          
    if (details.classList.contains('details--active')) {      
      details.classList.remove('details--active');
      detailsContent.setAttribute('aria-expanded', 'false');      
    } else {      
      details.classList.add('details--active');
      detailsContent.setAttribute('aria-expanded', 'true');      
    }     

    if(event.currentTarget.classList.contains('mmenu__hamburger')) {            
      document.body.classList.toggle('mmenu--open')
      document.body.classList.toggle('body-overlay')      
      summary.parentElement.addEventListener('keyup', onKeyUpEscape)      
    }    
  });   

  // Disable details functionality on desktop
  const mobileOnlyDetails = (summary) => {
    const details = summary.closest('.details');

    if(details.classList.contains('mobile--only')) {            
      if(window.innerWidth < 769){
        details.removeAttribute('open')
        details.classList.remove('details--active')         
        summary.setAttribute('aria-expanded', false)        
      } else {
        details.setAttribute('open', '')
        details.classList.add('details--active')
        summary.setAttribute('aria-expanded', true)        
      }      
    }     
  }
  
  window.addEventListener('DOMContentLoaded', mobileOnlyDetails(summary))    
});
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onLoad()
    this.addEventListener('change', this.onVariantChange);        
  }

  onVariantChange() {                             
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();    

    if (!this.currentVariant) {      
      this.toggleAddButton(true, '', true);
      this.setUnavailable();                   
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateUnavailableVariants()       
      this.updateSelectedValues()
    }    
  }

  onLoad() {             
    this.updateUnavailableVariants()        
    this.sortSizeOptions()
  }

  updateOptions() {    
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);        
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {        
        return this.options[index] === option;
      }).includes(false);
    });        
  }

  updateMedia() {        
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return
    
    const variantImage = this.currentVariant.featured_media.preview_image.src;    
            
    if(this.closest('.product-card')) {
      const media = this.closest('.product-card').querySelector('.product-card__media .media--primary')
      media.innerHTML = `<img src="${variantImage}&width=1440">`    
    } else {
      const carousel = document.querySelector('#main-carousel')
      if(!carousel) return
      const media = carousel.querySelector(`.splide__slide[data-media-position="${this.currentVariant.featured_media.position}"]`)            
      const mediaContainer = carousel.querySelector('.splide__list')

      if(carousel.classList.contains('is-active')) {
        var Slides = main.Components.Slides.filter( '.product__media-item' );

        if ( Slides[ this.currentVariant.featured_media.position ] ) {
          main.go( Slides[ this.currentVariant.featured_media.position ].index );
        }        
      } else {        
        mediaContainer.prepend(media)      
      }
    }    
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    const urlInput = shareButton.querySelector('input')
    let urlToShare = urlInput ? urlInput.value : document.location.href
    const url = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    urlToShare = url    
    urlInput.value = url
  }

  updateVariantInput() {    
    if(this.closest('.product-card')) {
      if(this.closest('form')) {
        const productCardInput = this.closest('form').querySelector('input[name="id"]');
        productCardInput.value = this.currentVariant.id;
        productCardInput.dispatchEvent(new Event('change', { bubbles: true }));
      }      
    } else {      
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }         
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    
    if (this.currentVariant && this.currentVariant.available) {      
      pickUpAvailability.style.display = 'block';
    } else {
      pickUpAvailability.style.display = 'none';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {    
    fetch(`${this.dataset.url.split('?')[0]}.json`)
      .then((response) => response.json())
      .then((data) => {                
        const variant = data.product.variants.filter(v => {
          return v.id === this.currentVariant.id
        })

        // const symbol = document.querySelectorAll('.price-item')[0].innerHTML.charAt(0)
        // let currency = document.querySelectorAll('.price-item')[0].innerHTML.split(' ')[1]	
        // if(currency == undefined) currency = ''	
        // let price, compare_price, badge, sticky_price
        // let compare_at_price = variant[0].compare_at_price
        // if(compare_at_price != '') {
        //   compare_at_price = symbol + variant[0].compare_at_price + ' ' + currency  
        // }        

        // if(this.closest('.product-card')) {                
        //   price = this.closest('.product-card').querySelector('.price-item--regular')
        //   compare_price = this.closest('.product-card').querySelector('.price-item--compare')          
        //   badge = this.closest('.product-card').querySelector('.badge--sale')
        // } else {
        //   price = this.closest('.product__info').querySelector('.price-item--regular') 
        //   sticky_price = this.closest('.product-wrapper').querySelector('.sticky-atc .price-item--regular')     
        //   compare_price = this.closest('.product__info').querySelector('.price-item--compare')                    
        //   badge = this.closest('.product__info').querySelector('.badge--sale')
        // }
          
        // if(price.closest('.price').querySelector('.price-varies__label')) {
        //   price.closest('.price').querySelector('.price-varies__label').remove()  
        // }

        // if(sticky_price.closest('.price').querySelector('.price-varies__label')) {
        //   sticky_price.closest('.price').querySelector('.price-varies__label').remove()  
        // }

        // price.innerHTML = symbol + variant[0].price + ' ' + currency                  
        // sticky_price.innerHTML = symbol + variant[0].price + ' ' + currency 

        // if(compare_price != undefined || compare_price != null) {          	
        //   compare_price.innerHTML = compare_at_price	
        //   if(compare_at_price != '') {            	
        //     if(badge) badge.classList.remove('visually-hidden')            	
        //   } else {	
        //     if(badge) badge.classList.add('visually-hidden')            	
        //   }	
          	
        // } else {	
        //   if(compare_at_price != ''){	
        //     const compare_price_new = document.createElement('div')	
        //     compare_price_new.classList.add('price-item')	
        //     if(this.closest('.product-card')) {	
        //       compare_price_new.innerHTML = `<s class="price-item price-item--compare">${compare_at_price}</s>`	
        //     } else {	
        //       compare_price_new.innerHTML = `<s class="price-item price-item--compare">${compare_at_price}</s><span class="badge badge--sale">Sale</span>`	
        //     }                    	
            	
        //     price.closest('.price-item--regular').parentNode.insertBefore(compare_price_new, price.closest('.price-item--regular').nextSibling);          	
        //   } 
        // }        
        
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })   
      
      if(document.getElementById('PreorderProperty')) {
        const preorder = document.getElementById('PreorderProperty')

        if(this.currentVariant.inventory_quantity == 0) {
          preorder.removeAttribute('name')
        } else {
          preorder.setAttribute('name', 'properties[Preorder]')          
        }
      }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let productForm;

    if(this.closest('.product-card')) {
      productForm = this.closest('form')            
    } else {      
      productForm = document.querySelector(`.single-product--form`);
    }    

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;    

      addButton.style.display = 'none';  
    } else {
      addButton.removeAttribute('disabled'); 
      if(document.getElementById('PreorderProperty')) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      addButton.style.display = 'flex'; 
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    let productForm
    if(this.closest('.product-card')) {
      productForm = this.closest('form')            
    } else {      
      productForm = document.querySelector(`.single-product--form`);       
    }
            
    const addButton = productForm.querySelector('[name="add"]');      
    const addButtonText = productForm.querySelector('[name="add"] > span');    

    if(addButton) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }
    
    if (addButton.hasAttribute('hidden')) {
      addButton.removeAttribute('hidden')
      setTimeout(() => addButton.setAttribute('hidden', ''), 3000)      
    } else {
          
    }    
  }  

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);    
    return this.variantData;
  }  

  getSelectedOption(i){
    if ( this.dataset.type == 'select' ) {
      return this.querySelectorAll('.product-form__input')[i].querySelector('select').value;
    } else {
      let selectedOption = null;
      this.querySelectorAll('.product-form__input')[i].querySelectorAll('input').forEach(elm=>{ if (elm.checked) selectedOption = elm.value });
      return selectedOption;
    }
  }

  setDisabledOption(i,option){		
    if ( this.dataset.type == 'select' ) {
  		//this.querySelectorAll('.product-form__input')[i].querySelector(`.variant-option[value="${option}"]`).setAttribute('disabled', '')
      this.querySelectorAll('.product-form__input')[i].querySelector(`.variant-option[value="${option}"]`).classList.add('sold-out')
  	} else {
  		this.querySelectorAll('.product-form__input')[i].querySelector(`.variant-option[value="${option}"]`).classList.add('sold-out')
  	}    
  }

  resetDisabledOption(i){    
		this.querySelectorAll('.product-form__input')[i].querySelectorAll('.variant-option').forEach((elm)=>{
      if ( this.dataset.type == 'select' ) {
        elm.removeAttribute('disabled');
      } else {
        elm.classList.remove('sold-out');
      }			
		})
  }

  updateUnavailableVariants(){
		if ( this.dataset.hideVariants == 'true' ) {
   		let options1 = {},
	        options2 = {},
	        options3 = {},

	        option1Selected = null,
	        option2Selected = null;

			if ( this.dataset.variants > 1 ) {
				option1Selected = this.getSelectedOption(0);
				this.resetDisabledOption(1);
      }
      if ( this.dataset.variants > 2 ) {
				option2Selected = this.getSelectedOption(1);
				this.resetDisabledOption(2);
      }
      
      this.getVariantData().forEach((el) => {
      	 if ( this.dataset.variants > 0 ) {
          if ( ! options1[el.option1] ) {
            options1[el.option1] = [];
          }
          options1[el.option1].push(String(el.available));
        }
        if ( this.dataset.variants > 1 ) {
          if ( ! options2[el.option2] ) {
            options2[el.option2] = [];
          }
          options2[el.option2].push(String(el.available));
        }
        if ( this.dataset.variants == 1 ) {          
          if ( ! el.available ) {
          	this.setDisabledOption(0, el.option1);
          }
        }
        if ( this.dataset.variants == 2 ) {                    
          if ( el.option1 == option1Selected) {                        
            if( ! el.available ) this.setDisabledOption(1, el.option2);     	
          }
        }
        if ( this.dataset.variants > 2 ) {
          if ( ! options3[el.option3] ) {
            options3[el.option3] = [];
          }
          options3[el.option3].push(String(el.available));
          if ( el.option2 == option2Selected && el.option1 == option1Selected && ! el.available ) {            
          	this.setDisabledOption(2, el.option3);            
            this.querySelectorAll('.product-form__input')[2].querySelector(`.variant-option[value="${el.option3}"] + label .variant-option-labels__sold-out`).style.display = 'flex';
            if(this.querySelectorAll('.product-form__input')[2].querySelector(`.variant-option[value="${el.option3}"] + label .variant-option-labels__preorder`)) {
              this.querySelectorAll('.product-form__input')[2].querySelector(`.variant-option[value="${el.option3}"] + label .variant-option-labels__preorder`).style.display = 'none';
            }
          }          
          
          if(el.inventory_quantity == 6) {
            this.querySelectorAll('.product-form__input')[2].querySelector(`.variant-option[value="${el.option3}"] + label .variant-option-labels__last-item`).style.display = 'block';
          }
        }        
      });            
		}
  }

  updateSelectedValues(){    
    if ( this.dataset.variants > 2 ) {      
      this.querySelectorAll('.product-form__input')[0].querySelector('#selectedOption').textContent = this.getSelectedOption(0)
      this.querySelectorAll('.product-form__input')[1].querySelector('#selectedOption').textContent = this.getSelectedOption(1)      
      this.querySelectorAll('.product-form__input')[2].querySelector('#selectedOption').textContent = this.getSelectedOption(2)                  
    } else if ( this.dataset.variants > 1 ) {
      this.querySelectorAll('.product-form__input')[0].querySelector('#selectedOption').textContent = this.getSelectedOption(0)
      this.querySelectorAll('.product-form__input')[1].querySelector('#selectedOption').textContent = this.getSelectedOption(1)        
    } else {
      this.querySelector('.product-form__input').querySelector('#selectedOption').textContent = this.getSelectedOption(0)
    }
  }

  sortSizeOptions(){
    const customOrder = ["x-small", "small", "medium", "large", "x-large", "xx-large", "xxx-large"];
    const container = document.querySelector(".size.product-form__input");
    
    const elements = Array.from(document.getElementsByClassName("sortable"));
    
    const sortedElements = elements
      .map(element => ({ element, order: customOrder.indexOf(element.dataset.sortValue) }))
      .sort((a, b) => {
        // If either aValue or bValue is not found in customOrder, move it to the end
        if (a.order === -1) return 1;
        if (b.order === -1) return -1;
    
        return a.order - b.order;
      })
      .map(item => item.element);
    
    sortedElements.forEach(element => {       
      container.appendChild(element)      
    });
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }    

  updateOptions() {      
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {                        
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });    
  }
}
customElements.define('variant-radios', VariantRadios);

if (!customElements.get('modal-dialog')) {
  customElements.define('modal-dialog', class ModalDialog extends HTMLElement {
    constructor() {
      super();            
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.hide());
      this.querySelector('#ModalOverlay').addEventListener('click', () => this.hide());
      this.querySelector('#ModalClose').addEventListener('click', (e) => {
        e.preventDefault()
        this.hide()
      });
      this.querySelectorAll('#ModalTrigger').forEach(el => el.addEventListener('click', (e) => {
        e.preventDefault()
        this.show()
      }));          
    }    

    hide() {
      this.querySelector('dialog').removeAttribute('open');
      this.querySelector('.modal').classList.toggle('modal--active');
      document.body.classList.remove('modal--open');      
      removeTrapFocus(this.querySelector('dialog').focusElement);
    }

    show(focusElement) {       
      this.querySelector('dialog').focusElement = focusElement;
      this.querySelector('dialog').setAttribute('open', '');
      this.querySelector('.modal').classList.toggle('modal--active');
      document.body.classList.add('modal--open');
      trapFocus(this);
    }
  });
}

if (!customElements.get('drawer-dialog')) {
  customElements.define('drawer-dialog', class DrawerDialog extends HTMLElement {
    constructor() {
      super();            
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.hide());
      this.querySelector('#drawerOverlay').addEventListener('click', () => this.hide());
      this.querySelector('#drawerClose').addEventListener('click', (e) => {
        e.preventDefault()
        if (this.querySelector('#drawerClose').classList.contains('drawer__close-container-only')) {
          this.hideContainer()
        } else {
          this.hide()
        }

      });
      this.querySelectorAll('.drawer-trigger').forEach(el => el.addEventListener('click', (e) => {
        e.preventDefault()
        this.show()
      }));          
    }    

    hide() {
      
      this.querySelector('.drawer').classList.toggle('drawer--active');
      document.body.classList.remove('drawer--open');      
      removeTrapFocus(this.querySelector('dialog').focusElement);

      setTimeout(() => {
        this.querySelector('dialog').removeAttribute('open');
      }, 250) 
    }

    hideContainer() {
      this.querySelector('.drawer').classList.toggle('drawer--active');     
      removeTrapFocus(this.querySelector('dialog').focusElement);

      setTimeout(() => {
        this.querySelector('dialog').removeAttribute('open');

        if (document.querySelectorAll('drawer-dialog dialog[open]').length == 0) {
          document.body.classList.remove('drawer--open');      
        }
      }, 250) 
    }

    show() {             
      this.querySelector('dialog').setAttribute('open', '');      
      setTimeout(() => {
        this.querySelector('.drawer').classList.toggle('drawer--active');  
        document.body.classList.add('drawer--open');                
      }, 250)         
      
      setTimeout(() => {        
        const containerToTrapFocusOn = this.querySelector('.drawer__container')
        const focusElement = this.querySelector('#drawerClose')
        trapFocus(containerToTrapFocusOn, focusElement);                
      }, 500)         
    }
  });
}   

class MainDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDrawer());
    this.querySelector('.drawer--overlay').addEventListener('click', () => this.closeDrawer());            
  }      

  openDrawer() {   
    this.focus()           
    this.classList.add('drawer--active');  
    document.body.classList.add('drawer--open');  
  }

  closeDrawer() {           
    this.classList.remove('drawer--active');  
    setTimeout(() => {      
      document.body.classList.remove('drawer--open');      
    }, 500)          
    document.activeElement.blur()    
  }  
}
customElements.define('main-drawer', MainDrawer);

// Close Mobile menu on overlay click
document.querySelector('.drawer--overlay').addEventListener('click', (e) => {
    e.target.closest('.details').querySelector('button').click()
})

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.bindEvents()
  }

  bindEvents() {
    this.querySelectorAll('.submenu__trigger').forEach(trigger => {
      trigger.addEventListener('click', (el) => {                              
        el.target.closest('li').querySelector('.menu-drawer__content').style.display = 'block'                
        el.target.closest('li').querySelector('.menu-drawer__content').setAttribute('aria-expanded', true)        
        document.querySelector('.mmenu-drawer .drawer__container').scrollTo({top: 0, behavior: 'smooth'})
        setTimeout(() => {
          el.target.closest('li').querySelector('.menu-drawer__content').classList.add('submenu--active')
          document.querySelector('.mmenu-drawer .drawer__container').classList.add('submenu--showing')
        }, 100)        
      })
    })

    this.querySelectorAll('#MenuBreadcrumb0').forEach(el => {
      el.addEventListener('click', () => {      
        if(el.closest('.menu-level-2') && el.closest('.menu-level-2').classList.contains('submenu--active')){
          el.closest('.menu-level-2').classList.remove('submenu--active')
          el.closest('.menu-level-2').setAttribute('aria-expanded', false)

          setTimeout(() => {
            el.closest('.menu-level-2').style.display = 'none'
          }, 100)        
        }
        
        el.closest('.menu-level-1').classList.remove('submenu--active')      
        el.closest('.menu-level-1').setAttribute('aria-expanded', false)
        document.querySelector('.mmenu-drawer .drawer__container').classList.remove('submenu--showing')        

        setTimeout(() => {
          el.closest('.menu-level-1').style.display = 'none'
        }, 100)        
      })
    })
    

    this.querySelectorAll('#MenuBreadcrumb1').forEach(el => {
      el.addEventListener('click', () => {
        el.closest('.menu-level-2').classList.remove('submenu--active')

        setTimeout(() => {
          el.closest('.menu-level-2').style.display = 'none'
        }, 100)        
      })
    })
  }
}

customElements.define('menu-drawer', MenuDrawer);

if (!customElements.get('search-drawer')) {
  customElements.define('search-drawer', class SearchDrawer extends HTMLElement {
    constructor() {
      super();      
      document.querySelectorAll('.search-trigger').forEach(el => el.addEventListener('click', () => this.show()));
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.hide());
      this.querySelector('#DrawerOverlay').addEventListener('click', () => this.hide());
      this.querySelector('#DrawerClose').addEventListener('click', () => this.hide());          
    }    

    hide() {
      this.classList.remove('drawer--active');
      document.body.classList.remove('drawer--open');
      removeTrapFocus(this.querySelector('.drawer__container'));    
      trapFocus(document.body, document.body);        
    }

    show() {      
      this.classList.add('drawer--active');
      document.body.classList.add('drawer--open');
      setTimeout(() => {
        const containerToTrapFocusOn = this.querySelector('.drawer__container')
        const focusElement = this.querySelector('#SearchInput')
        trapFocus(containerToTrapFocusOn, focusElement);        
      }, 250)                
    }    
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card .media--primary').forEach(el => {
    const img = el.querySelector('img')
    img.setAttribute('alt', `View 1 - ${img.getAttribute('alt')}`)
  })
  
  document.querySelectorAll('.product-card .media--rollover').forEach(el => {
    const img = el.querySelector('img')
    img.setAttribute('alt', `View 2 - ${img.getAttribute('alt')}`)
  })

  
  setTimeout(() => {
    document.querySelectorAll('.splide__track').forEach(el => {
      el.removeAttribute('aria-live')
      el.removeAttribute('aria-atomic')
    })

    document.querySelectorAll('.splide__list').forEach(el => {
      el.removeAttribute('role')      
    })
  }, 3000)      
});

function jsGridItem(hit) { 
  //console.log('jsGridItem ========')
  //console.log(hit)
  let customBadgeHTML = ''; 
  if(hit.hasOwnProperty('customFields') && hit.available){
    let customBadge = hit.customFields.filter(field => field.key == 'custom-custom_budge');
    //console.log('customBadge')
    if(customBadge.length > 0){
      let fieldObj = JSON.parse(customBadge[0].value)
      customBadgeHTML = `<div class="custom-badge content--floating">${fieldObj?.children[0]?.children[0]?.value}</div>`;
      console.log(fieldObj?.children[0]?.children[0]?.value)
    }
  }
  let finalSaleBadge = '';
  if(hit?.tags1.includes('FINALSALE') || hit?.tags1.includes('finalsale') || hit?.tags1.includes('FINALSALE FP')){
    finalSaleBadge = `<span class="final-sale-badge">Final Sale</span>`
  }

  let titleArr = hit.name.split(' - ');
  let title = hit.name;
  let colorName = titleArr[titleArr.length - 1];
  if(titleArr.length == 2){
    title = titleArr[0];
  } else if (titleArr.length > 2){
    title = titleArr[1];
  }

  let discountPriceEl = ``;

  //let saleTagDisc = ['PFAW24SALE40:40', 'PFAW24MSALE40:40','PFAW24WSALE40:40', 'PFAW24KSALE40:40'];
  // saleTagDisc is defined in "sections/main-collection-product-grid.liquid"

  let discountApplied = false;
  saleTagDisc.forEach(item => {
    let tag = item.split(':')[0];
    let disc = item.split(':')[1];
    //console.log('disc')
    //console.log(disc)

    if(hit.tags1.includes(tag) && !discountApplied){
      let discount = hit.price * disc / 100;
      discountPriceEl = `<span class="price-item- price-item--discounted" aria-label="Price">          
          ${Shopify.nosto.money_format.split('{{')[0]} ${ hit.price - discount} ${hit.priceCurrencyCode}
        </span>`
      console.log('discount')
      console.log(discount)
      discountApplied = true;
    }
  })

  let urlParams = '';
  if(window.location.pathname == '/search'){
    urlParams = '?serpclick=1';
  } else {
    urlParams = '?categoryclick=1';
  }
  
  function numberWithCommas(x) {
    //return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return x;
  }

  let primaryImage = sizeImage(hit.imageUrl);
  let hoverImage = sizeImage(hit.imageUrl);

  if(hit.alternateImageUrls) {
    if(hit.alternateImageUrls.length > 0) {
      hoverImage = sizeImage(hit.alternateImageUrls[0]);
    }
  }

  function sizeImage(url){
    if(url.includes('?')){
      return url += '&width=760&height=1014&crop=center'
    } else {
      url += '?width=760&height=1014&crop=center'
    }
  }
  
  let soldOutBadgeHTML = '';
  if(!hit.available) {
    soldOutBadgeHTML = '<span class="badge badge--sold-out">SOLD OUT</span>';
  }
  let moreColorsArr = hit.customFields.filter(field => field.key == "custom-more_colors");

  let initialSwatchHTML = ""

  if(moreColorsArr.length ){

    let swatchBorder = "";
    if(colorName.toLowerCase() == "white"){
      swatchBorder = " swatch__border";
    }

    let productIdArr = moreColorsArr[0].value.replace('[','').replace(']','').replaceAll('"',"").split(",")

    let moreSwatchesCountHTML = ``; 

    if(productIdArr.length > 2) {
      moreSwatchesCountHTML += ` +${productIdArr.length - 2}`
    }
    initialSwatchHTML = `
      <div class="swatches flex">
        <ul class="flex list-unstyled" id="swatches-list-${hit.productId}">
          <li><a href="${hit.url}${urlParams}" class="swatch selected${swatchBorder}" style="background: ${colorNameToSwatchBg(colorName)}"></a></li>
        </ul>
        <div id="more-swatches-count-${hit.productId}" class="more-swatches-count">${moreSwatchesCountHTML}</div>
      </div>`
    //console.log('moreColorsArr[0]')
    //console.log(moreColorsArr[0].value)
    //console.log('productIdArr')
    //console.log(productIdArr)

    productIdArr.forEach((pid, i) => {
      if(i < 2) {
        async function getData (pid){
          const res = await getProduct(pid);
          //console.log('res.data.product')
          //console.log(res.data.product)
          let productColorOption = res.data.product.options.find(opt => opt.name.toLowerCase() == "color");
          if(productColorOption === undefined) return;
          //console.log('productColorOption.values[0]')
          //console.log(productColorOption.values[0])
          let productColorName = productColorOption.values[0]; 
          let swatchBorder = "";
          if(productColorName.toLowerCase() == "white"){
            swatchBorder = " swatch__border";
          }
          let swatch = `<li><a href="${Shopify.routes.root}products/${res.data.product.handle}${urlParams}" class="swatch${swatchBorder}" style="background: ${colorNameToSwatchBg(productColorName)}"></a></li>`
          document.getElementById('swatches-list-'+ hit.productId).insertAdjacentHTML('beforeend', swatch)
        }
        getData(pid);
      }
    })
  }
  
  const url = `${Shopify.routes.root}${hit.url.replace('https://amiri.com/', '')}${urlParams}`;

  let price = '';
  if(Shopify.country == 'US'){
    price =
      `<div class="price-rating__wrapper body-1">

        <div id="price-" class="price flex aic flex--wrap flex--gap" style="--flex-gap: 0 .5rem">
          <span class="price-item- price-item--regular" aria-label="List price">
            ${Shopify.nosto.money_format.split('{{')[0]} ${numberWithCommas(hit.price)} ${hit.priceCurrencyCode}
          </span>
          ${discountPriceEl}
          <span class="price-item price-item--list" aria-label="List price"></span>
        </div>

      </div>`;
  }

  return `
  <li class="grid__item" x-nosto-handle="${hit.url.split('/products/')[1]}">

    <div id="${hit.productId}" class="product-card product-card--wishlist nosto-product-url" role="group" aria-label="product">

      <a 
        href="${url}"
        title="Navigate to product ${hit.name}"
        id="${hit.productId}"
      >
        <div 
          class="product-card__media container media media-ratio" 
          style="--media-ratio:133.33333333333334%"
          id="${hit.productId}"
        >
          ${soldOutBadgeHTML}
          ${customBadgeHTML}
          <div class="media-container flex">
            <div class="media--primary">
              <img src="${primaryImage}" width="760" height="1014" alt="${hit.name}" />
            </div>
            <div class="media--rollover">
              <img src="${hoverImage}" width="760" height="1014" alt="${hit.name}" />
            </div>
          </div>

          <ul class="media-pagination flex jcc aic list-unstyled">
            <li></li>
            <li></li>          
          </ul>

        </div>
      </a>


      <div class="product-card__info">

        <div class="flex jcb flex--mobile">
          <div>
            <h3 class="product-card__title link-styled x-nosto-title-">
              ${title} ${finalSaleBadge}
            </h3>

            ${price}
          </div>

          ${initialSwatchHTML}

        </div>
      </div>

    </div>

  </li>`
}

function getProduct(pid){
  return new Promise((resolve) => {
    const query =  `query getProductById($id: ID!) {
      product(id: $id) {
        title,
        handle,
        options {
          name,
          values
        }
      }
    }`

    fetch('https://amiri.com/api/graphql', {
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token":"68d11816385ea789f19867aece58644f",
      "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ 
        query: query,
        variables: {
          id: `${pid}`,
        }
      })
    }).then(res => {
      //console.log('res----')
      //console.log(res)
      return res.json();  
    }).then(data => {
      resolve(data)
    }).catch(err => {
      console.log(err)
    })
  });
}

function colorNameToSwatchBg(name){
  let swatchBgArr = colorSwatchConfig.filter(obj => obj.name.toLowerCase() == name.toLowerCase());
  let value = name.toLowerCase();

  if(swatchBgArr.length){
    if(!swatchBgArr[0].value.includes('#')){

      let size = '&width=11&height=11&crop=center';
      if(!swatchBgArr[0].value.includes('?')){
        size += '?width=11&height=11&crop=center'
      } 

      value = `url('${swatchBgArr[0].value}${size}')`
    } else {
      value = swatchBgArr[0].value;
    }
  }
  return value;
}

function addMediaScrollListeners(){
  // Mobile product card slider
  document.querySelectorAll(".media-container").forEach(container => {
    container.addEventListener("scroll", () => {
        const slides = container.querySelectorAll("div");
        if (slides.length < 2) return; // Ensure there is a second slide

        const secondSlide = slides[1]; // The second slide
        const containerScrollLeft = container.scrollLeft;
        const slideLeft = secondSlide.offsetLeft;
        const containerWidth = container.clientWidth;        

        // Check if second slide is centered within the viewport
        if (containerScrollLeft >= slideLeft - containerWidth / 2 && 
            containerScrollLeft < slideLeft + containerWidth / 2) {
            container.closest('.product-card__media').querySelector('.media-pagination').classList.add("second-slide-active");
        } else {
            container.closest('.product-card__media').querySelector('.media-pagination').classList.remove("second-slide-active");
        }
    });
  });
}